// Components==============
import ReflectionItem from 'pages/Growth/Reflect/components/ReflectionItem/ReflectionItem';
import './Views.module.scss';
import React, { useContext, useEffect } from 'react';
import GridFiller from 'components/UI/GridFiller/GridFiller';
import { GlobalReflectionContext } from 'utilities/GlobalContext/GlobalReflectionContext';
import { useRedux } from 'hooks/useRedux';
import { usePermission } from 'hooks/usePermission';
import { ReflectContext } from '../Reflect';
// =========================

export default function EndReflectionView() {
  const {
    endPointActivities,
    endPointActivity,
    wrapperRef,
    setSelectedStudent,
  } = useContext(ReflectContext);

  const isTeacher = usePermission(['Docent', 'super-admin']);
  const { selectedReflection } = useContext(GlobalReflectionContext);

  const selectedReflectionUser = useRedux(
    (state) => state.reflection?.entities.byId[selectedReflection]?.user
  );

  useEffect(() => {
    if (selectedReflectionUser && isTeacher)
      setSelectedStudent(
        `${selectedReflectionUser.first_name} ${selectedReflectionUser.last_name}`
      );
  }, []);

  return (
    <div styleName="wrapper" ref={wrapperRef}>
      {endPointActivities?.map(
        (activity) =>
          !!activity && <ReflectionItem activity={activity} key={activity.id} />
      )}
      {!!endPointActivity && <ReflectionItem activity={endPointActivity} />}
      <GridFiller />
    </div>
  );
}
